import {combineReducers} from 'redux';
import HolidayPackage from './HolidayPackage';

const rootReducers = combineReducers({
    HolidayPackage
});

export default rootReducers;